import {
  BaseCurrencyInput,
  Button,
  Checkbox,
  Drawer,
  Input,
  Label,
  Loading,
  Message,
  Select,
  Title,
} from "@components";

import { OnboardingAPI } from "providers/OnboardingAPI";
import { Fragment, useEffect, useState } from "react";
import { ForEach, If } from "shared/components/control-statements";
import { InfoCircle } from "shared/components/Icons";
import { InputSearch } from "shared/components/InputSearch";
import { useDragScroll } from "shared/hooks/useDragScroll";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import styles from "styles/create-flows.module.scss";
import { v4 as uuid } from "uuid";

import { useDebouncedCallback } from "@hooks";
import classNames from "classnames/bind";
import "leaflet/dist/leaflet.css";
import { FlowAPI } from "providers/FlowAPI";
import OcdpAPI2 from "providers/OcdpAPI2";
import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import { AudiencesTable } from "shared/containers/cdp/audiences/AudiencesTable";
import { Environment } from "shared/core/Environment";
import { BenefitEnvironment } from "../boxesOraculo/forms/actions/components/BenefitEnvironment";
const css = classNames.bind(styles);

const COUPON_TYPE = {
  CASH_DISCOUNT: "CASH_DISCOUNT",
  PERCENTAGE_DISCOUNT: "PERCENTAGE_DISCOUNT",
  FREE_DELIVERY: "FREE_DELIVERY",
  CASHBACK: "CASHBACK",
  PRODUCT_DISCOUNT: "PRODUCT_DISCOUNT",
};

const ocdp_api = new OcdpAPI2();

const emptyCreative = {
  type: "SMS",
  name: "",
  time: "",
  sender: "",
  cta: "",
  contemplation: "SEVERAL_TIMES",
  contemplation_day_interval: "",
  coupon_type: null,
  max_gain: 0,
  skus: "",
  coupon_code: "",
  coupon_value: "",
  min_order: "",
  expiration: "",
  operation_type: "",
  brands_valid: null,
  message_title: "",
  message_body: "",
};

const emptyFlow = {
  name: "",
  folder: "",
  audience_name: "",
  audience_type: "",
  audience: "",
  creatives: [emptyCreative],
};

const COPY_NAMES = {
  name: "Nome do fluxo",
  folder: "Pasta do fluxo",
  audience_type: "Tipo de público",
  audience: "Público",
  creative_type: "Canal",
  creative_name: "Nome do criativo",
  creative_sender: "Remetente",
  creative_cta: "CTA",
  creative_cta_type: "CTA",
  creative_time: "Momento do disparo",
  creative_contemplation: "Tipo de contemplação",
  creative_contemplation_day_interval: "Intervalo de contemplação",
  creative_coupon_type: "Tipo do cupom",
  creative_coupon_code: "Código do cupom",
  creative_max_gain: "Limite de ganho de cashback/pontos",
  creative_coupon_skus: "SKUS",
  creative_coupon_value: "Valor do cupom",
  creative_min_order: "Pedido mínimo do cupom",
  creative_expiration: "Expiração do cupom",
  creative_operation_type: "Operações do cupom",
  creative_brands_valid: "Marcas válidas",
  creative_message_title: "Título da mensagem",
  creative_message_body: "Mensagem",
};

const validatePhoneAndPrefix = (phones) => {
  if (!phones) return false;
  const phoneValid = phones.replace(/\D/g, "").length === 11;
  const prefixValid = /^\+\d{2}$/.test("+55");
  return phoneValid && prefixValid;
};

export default function CreateFlows() {
  const [flows, setFlows] = useState([]);
  const [selectedFlows, setSelectedFlows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [folders, setFolders] = useState([]);
  const [audiences, setAudiences] = useState([]);
  const [openAudiences, setOpenAudiences] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [selectedAudience, setSelectedAudience] = useState(null);
  const [holdingId, setHoldingId] = useState(null);
  const [openCopyFlow, setOpenCopyFlow] = useState(false);
  const [openCopyCreative, setOpenCopyCreative] = useState(false);
  const [toCopy, setToCopy] = useState(null);
  const [fieldToCopy, setFieldToCopy] = useState({});
  const [openAddMultiple, setOpenAddMultiple] = useState(false);
  const [flowsToAdd, setFlowsToAdd] = useState("");
  const [openConfirmRemove, setOpenConfirmRemove] = useState(false);
  const [selectedCreative, setSelectedCreative] = useState({});
  const [openSendTest, setOpenSendTest] = useState(false);
  const [openBrands, setOpenBrands] = useState(false);

  const SmsTriggerShot = () => {
    const [phones, setPhones] = useState("");
    const [remainTime, setRemainTime] = useState(0);
    const [isWaitingSending, setIsWaitingSending] = useState(false);

    const sendSmsTest = async () => {
      const environmentId = Environment.id;

      const { coupon_code, message_body, sender, cta_type, cta } =
        selectedCreative;

      if (!validatePhoneAndPrefix(phones)) return;

      const phone = `+55${phones}`.replace(/[^0-9]/g, "");

      let benefit = "";
      if (coupon_code) benefit = `${coupon_code}-A10`;

      let template = message_body;

      template = `${template || ""}<link>`;

      setIsWaitingSending(true);
      const response = await FlowAPI.sendSmsTest(environmentId, {
        phone: phone,
        urlType: cta_type,
        template: template,
        replacements: {
          "<cupom>": benefit,
          "<link>":
            cta_type === "STANDARD"
              ? `${Environment.defaultShortUrl}`
              : `${cta}`,
          "<remetente>": sender
            ? sender.includes(":")
              ? `${sender}`
              : `${sender}:`
            : "",
        },
      });

      if (response.getCode(500) != 200) {
        const errorMessage = response.getErrors([
          "Ocorreu um erro no sistema!",
        ])[0];
        alert({ text: errorMessage });
        setIsWaitingSending(false);
        return;
      }

      const startTimer = () => {
        let startTime = 60;
        const intervalId = setInterval(() => {
          setRemainTime(startTime--);
          if (startTime == -1) {
            clearInterval(intervalId);
            setIsWaitingSending(false);
          }
        }, 1000);
      };
      startTimer();
    };

    const onSendSms = useDebouncedCallback(sendSmsTest, 1000);

    return (
      <>
        <Label>
          Informe o seu número de telefone para que possamos realizar um disparo
          teste.
        </Label>

        <div className={styles.testMessage}>
          <div className="d-flex align-center">
            <Input
              placeholder="(00) 00000-0000"
              className="w-100"
              center
              value={phones}
              mask="(99) 99999-9999"
              onChange={(e) => setPhones(e.target.value)}
              disabled={isWaitingSending}
            />
          </div>

          <Button
            design="primary"
            className="mt-15 w-100"
            disabled={
              isWaitingSending ||
              (!isWaitingSending && !validatePhoneAndPrefix(phones))
            }
            onClick={onSendSms}
          >
            Disparar
            <If cond={remainTime > 0}>
              <span>
                &nbsp;(
                {`${`${Math.floor(remainTime / 60)}`.padStart(2, "0")}:${`${
                  remainTime % 60
                }`.padStart(2, "0")}`}
                )
              </span>
            </If>
          </Button>
        </div>
      </>
    );
  };

  const PushTriggerShot = () => {
    const [phones, setPhones] = useState("");
    const [remainTime, setRemainTime] = useState(0);
    const [isWaitingSending, setIsWaitingSending] = useState(false);

    const sendPushTest = async () => {
      const environmentId = Environment.id;

      const {
        coupon_code,
        message_body,
        message_title,
        sender,
        cta_type,
        cta,
      } = selectedCreative;

      if (!validatePhoneAndPrefix(phones)) return;

      const phone = `+55${phones}`.replace(/[^0-9]/g, "");

      let benefit = "";
      if (coupon_code) benefit = `${coupon_code}-A10`;

      let template = message_body;

      setIsWaitingSending(true);
      const response = await FlowAPI.sendPushTest(environmentId, {
        phone: [phone],
        urlType: cta_type,
        title: message_title,
        template: template,
        replacements: {
          "<cupom>": benefit,
          "<link>":
            cta_type === "STANDARD"
              ? `${Environment.defaultShortUrl}`
              : `${cta}`,
          "<remetente>": sender,
        },
      });

      if (response.getCode(500) != 200) {
        const errorMessage = response.getErrors([
          "Ocorreu um erro no sistema!",
        ])[0];
        alert({ text: errorMessage });
        setIsWaitingSending(false);
        return;
      }

      setIsWaitingSending(true);
      const startTimer = () => {
        let startTime = 60;
        const intervalId = setInterval(() => {
          setRemainTime(startTime--);
          if (startTime == -1) {
            clearInterval(intervalId);
            setIsWaitingSending(false);
          }
        }, 1000);
      };
      startTimer();
    };

    const onSendPush = useDebouncedCallback(sendPushTest, 1000);

    return (
      <>
        <Message
          text="Insira um número de telefone cadastrado no aplicativo, para que
          possamos enviar um teste. Lembre-se, você só receberá a simulação se
          tiver logado no aplicativo, em um cadastro com o mesmo número que será
          inserido abaixo."
          className="mb-20"
        ></Message>

        <div className={styles.testMessage}>
          <div className="d-flex align-center">
            <Input
              placeholder="(00) 00000-0000"
              className="w-100"
              center
              value={phones}
              mask="(99) 99999-9999"
              onChange={(e) => setPhones(e.target.value)}
              disabled={isWaitingSending}
            />
          </div>

          <Button
            design="primary"
            className="mt-15 w-100"
            disabled={
              isWaitingSending ||
              (!isWaitingSending && !validatePhoneAndPrefix(phones))
            }
            onClick={onSendPush}
          >
            Disparar
            <If cond={remainTime > 0}>
              <span>
                &nbsp;(
                {`${`${Math.floor(remainTime / 60)}`.padStart(2, "0")}:${`${
                  remainTime % 60
                }`.padStart(2, "0")}`}
                )
              </span>
            </If>
          </Button>
        </div>
      </>
    );
  };

  const fetchAudiences = async () => {
    const audiences = await ocdp_api.audiences();

    const filtered_audiences = audiences.filter((a) => a.state != "ARCHIVED");

    const sortedAudiences = filtered_audiences.sort(
      (a, b) =>
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
    );

    setAudiences(
      sortedAudiences.map((a) => ({
        id: a.id,
        name: a.name,
        type: a.type,
        status: a.status,
        brand_id: a.brand_id,
        brand: a.brand || { id: a.brand_id },
        unit_id: a.unit_id,
        flow: a.flow || { id: a.unit_id },
        schema: a.schema,
        filters: a.filters,
        boxes: a.boxes,
        links: a.links,
        state: a.state,
        execution_id: a.execution_id,
        qtd_customers: a.customers || 0,
        previous_qtd_customers: a.previous_customers || 0,
        qtv_variables: a.schema?.length || 0,
        sort: a.extras?.sort,
        limit: a.extras?.limit,
        version: a.version,
        updated_at: a.updated_at,
      })),
    );
  };

  const loadFolders = async () => {
    const environmentConfigurations =
      await OlgaEnvironmentsAPI.getConfigurations();
    const folders = environmentConfigurations.getData({})?.flow_folders || [];
    setFolders(folders);
  };

  const { scrollRef, onMouseDown } = useDragScroll();

  const updateFlowsByIds = (flows, selectedFlowIds, field, value) => {
    if (!Array.isArray(flows) || !Array.isArray(selectedFlowIds)) return flows;

    return flows.map((flow) =>
      selectedFlowIds.includes(flow.id) ? { ...flow, [field]: value } : flow,
    );
  };

  const updateCreativeFlowByIds = (
    data,
    selectedFlows,
    field,
    newValue,
    creativeIndex,
  ) => {
    if (!Array.isArray(data) || !Array.isArray(selectedFlows) || !field)
      return data;

    return data.map((flow) => {
      if (!selectedFlows.includes(flow.id)) return flow;

      const creatives = [...(flow.creatives || [])];

      if (!creatives[creativeIndex]) return flow;

      creatives[creativeIndex] = {
        ...creatives[creativeIndex],
        [field]: newValue,
      };

      return {
        ...flow,
        creatives,
      };
    });
  };

  const updateCreative = (flowId, index, field, value) => {
    setFlows((prev) =>
      prev.map((flow) =>
        flow.id === flowId
          ? {
              ...flow,
              creatives: flow.creatives.map((creative, i) =>
                i === index ? { ...creative, [field]: value } : creative,
              ),
            }
          : flow,
      ),
    );
  };

  const Items = () => {
    const [search, setSearch] = useState("");

    const filteredFlows = flows.filter((flow) => {
      const searchLower = search.toLowerCase();
      return flow.name.toLowerCase().includes(searchLower);
    });

    return (
      <div className={styles.itemsContainer}>
        <InputSearch
          placeholder="Buscar por..."
          onChange={(e) => setSearch(e.target.value)}
          design="two"
          className="mt-20"
        />

        <div className={styles.header}>
          <p>{selectedFlows.length} selecionado(s)</p>
          <Checkbox
            checked={selectedFlows.length === flows.length}
            onChange={() => {
              if (selectedFlows.length === flows.length) setSelectedFlows([]);
              else setSelectedFlows(flows.map((b) => b.id));
            }}
          />
        </div>
        <ForEach
          items={filteredFlows}
          render={(item) => {
            return (
              <div
                className={styles.brand}
                onClick={() => {
                  if (selectedFlows.includes(item.id))
                    setSelectedFlows((prev) =>
                      prev.filter((b) => b !== item.id),
                    );
                  else setSelectedFlows((prev) => [...prev, item.id]);
                }}
              >
                <Checkbox checked={selectedFlows.includes(item.id)} />
                <p className={styles.brandName}>
                  {item.name || "Fluxo sem nome"}
                </p>
              </div>
            );
          }}
        />
      </div>
    );
  };

  const handleFlow = (flowId, updates) => {
    setFlows((prev) =>
      prev.map((flow) => (flow.id === flowId ? { ...flow, ...updates } : flow)),
    );
  };

  const handleDeleteFlow = (flowId) => {
    setFlows((prev) => prev.filter((flow) => flow.id !== flowId));
  };

  const handleCreative = (flowId, index, field, value) => {
    setFlows((prev) =>
      prev.map((flow) =>
        flow.id === flowId
          ? {
              ...flow,
              creatives: flow.creatives.map((creative, i) =>
                i === index ? { ...creative, [field]: value } : creative,
              ),
            }
          : flow,
      ),
    );
  };

  const save = async () => {
    setLoading(true);

    const response = await FlowAPI.importJsonFlows(Environment.id, flows);

    if (response.getErrors({}).length > 0) {
      setOpenError(true);
      setErrorMessage(response.getErrors({})[0]);
    } else setOpenSuccess(true);

    setLoading(false);
  };

  const getBrands = async () => {
    try {
      const response = await OlgaEnvironmentsAPI.getBrands();
      const brands = response.getData([]);
      setBrands(brands);
    } catch (error) {
      setBrands([]);
    }
  };

  useEffect(() => {
    getBrands();
  }, []);

  const generateTimeRange = () => {
    const timeHourOptions = [];

    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 1; minutes++) {
        timeHourOptions.push(
          `${`${hours}`.padStart(2, "0")}:${`${minutes * 60}`.padStart(
            2,
            "0",
          )}`,
        );
      }
    }

    return timeHourOptions;
  };

  const getTimeRange = (begin = "00:00", label = false) => {
    const timeRange = generateTimeRange(label);
    const indexOfBegin = timeRange.indexOf(begin);

    const validTimeRange = timeRange.slice(indexOfBegin);

    return validTimeRange;
  };

  const getTimes = () => {
    const times = getTimeRange();

    return times.map((time) => {
      return {
        value: time,
        label: time,
      };
    });
  };

  const maxCreatives = Math.max(...flows.map((f) => f.creatives?.length || 0));

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchAudiences();
      setLoading(false);
    };

    fetchData();
    loadFolders();

    setFlows([{ id: uuid(), ...emptyFlow }]);
  }, []);

  const getHoldingId = async () => {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    setHoldingId(holdingId);
  };

  useEffect(() => {
    getHoldingId();
  }, []);

  let MAX_CHARS_PER_SMS = 150;
  const MAX_CHARS_PUSH = 160;

  const isCiaTC = holdingId && holdingId === 811;
  const isCocoBambu = Environment.id === 49;

  if (isCocoBambu) MAX_CHARS_PER_SMS = 145;

  const getCopyName = () => COPY_NAMES[toCopy] ?? "";

  const programByPoint =
    localStorage.getItem("cashbackProgramType") === "POINT";

  return (
    <div className={styles.onboardingComponent}>
      <If cond={loading}>
        <Loading fullContent />
      </If>

      <Title
        title="Criação de fluxos"
        backTo={{ name: "Fluxos", url: "/fluxos" }}
      />

      <div className={styles.onboardingContainer}>
        <div
          onMouseDown={onMouseDown}
          ref={scrollRef}
          className={styles.table}
          style={{ maxHeight: "calc(100dvh - 220px)" }}
        >
          <table>
            <thead>
              <tr>
                <th
                  style={{
                    minWidth: 40,
                    position: "sticky",
                    left: 0,
                    zIndex: 200,
                  }}
                />
                <th
                  style={{
                    minWidth: 500,
                    position: "sticky",
                    left: 59,
                    zIndex: 200,
                  }}
                >
                  Nome do fluxo
                </th>
                <th
                  style={{
                    minWidth: 500,
                  }}
                >
                  Pasta do fluxo
                </th>
                <th>Tipo de público</th>
                <th
                  style={{
                    minWidth: 500,
                  }}
                >
                  Público
                </th>
                {Array.from({ length: maxCreatives }).map((_, idx) => {
                  const index = idx + 1;

                  return (
                    <Fragment key={idx}>
                      <th>Criativo {index} - Canal</th>
                      <th
                        style={{
                          minWidth: 500,
                        }}
                      >
                        Criativo {index} - Nome do criativo
                      </th>
                      <th>Criativo {index} - Momento do disparo</th>
                      <th>Criativo {index} - Remetente</th>
                      <th>Criativo {index} - CTA</th>
                      <th>Criativo {index} - URL personalizada</th>
                      <th>Criativo {index} - Tipo de contemplação</th>
                      <th>Criativo {index} - Intervalo de contemplação</th>
                      <th>Criativo {index} - Tipo do cupom</th>
                      <th>
                        Criativo {index} - Limite de ganho cashback/pontos
                      </th>
                      <th>Criativo {index} - SKUs (cupom de produto)</th>
                      <th>Criativo {index} - Código cupom</th>
                      <th>Criativo {index} - Valor cupom</th>
                      <th>Criativo {index} - Pedido mínimo cupom</th>
                      <th>Criativo {index} - Expiração cupom</th>
                      <th>Criativo {index} - Operações cupom</th>
                      <If cond={brands.length > 1}>
                        <th>Criativo {index} - Marcas válidas</th>
                      </If>
                      <th
                        style={{
                          minWidth: 500,
                        }}
                      >
                        Criativo {index} - Título Mensagem (Push)
                      </th>
                      <th
                        style={{
                          minWidth: 500,
                        }}
                      >
                        Criativo {index} - Mensagem
                      </th>
                      <th>Testar criativo</th>
                    </Fragment>
                  );
                })}
                <th>Adicionar criativo</th>
              </tr>
            </thead>
            <tbody>
              {flows.map((flow) => {
                return (
                  <tr>
                    <td
                      style={{
                        minWidth: 40,
                        position: "sticky",
                        left: 0,
                        zIndex: 200,
                      }}
                    >
                      <Button
                        tabIndex="-1"
                        design="default-icon-mini-2"
                        onClick={() => {
                          setSelectedFlow(flow);
                          setOpenConfirmRemove(true);
                        }}
                      >
                        <i className="fal fa-trash-alt" />
                      </Button>
                    </td>
                    <td
                      style={{
                        minWidth: 500,
                        position: "sticky",
                        left: 59,
                        zIndex: 200,
                      }}
                    >
                      <div className="d-flex align-center gap-10">
                        <Input
                          design="mini"
                          className="w-100"
                          value={flow.name}
                          onChange={(e) =>
                            handleFlow(flow.id, {
                              name: e.target.value,
                            })
                          }
                          filled={!!flow.name}
                        />
                        <Button
                          tabIndex="-1"
                          design="default-icon-mini-2"
                          onClick={() => {
                            setOpenCopyFlow(true);
                            setFieldToCopy({
                              name: "name",
                              value: flow.name,
                            });
                            setToCopy("name");
                            setSelectedFlow(flow);
                          }}
                        >
                          <i className="fal fa-layer-group" />
                        </Button>
                      </div>
                    </td>
                    <td
                      style={{
                        minWidth: 500,
                      }}
                    >
                      <div className="d-flex align-center gap-10">
                        <Select
                          design="mini"
                          className="w-100"
                          value={flow.folder}
                          onChange={(e) =>
                            handleFlow(flow.id, {
                              folder: e.target.value,
                            })
                          }
                          options={[
                            { label: "---", value: "" },
                            ...folders.map((f) => ({
                              label: f.name,
                              value: f.id,
                            })),
                          ]}
                          filled={!!flow.folder}
                        />
                        <Button
                          tabIndex="-1"
                          design="default-icon-mini-2"
                          onClick={() => {
                            setOpenCopyFlow(true);
                            setFieldToCopy({
                              name: "folder",
                              value: flow.folder,
                            });
                            setToCopy("folder");
                            setSelectedFlow(flow);
                          }}
                        >
                          <i className="fal fa-layer-group" />
                        </Button>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-center gap-10">
                        <Select
                          design="mini"
                          className="w-100"
                          value={flow.audience_type}
                          onChange={(e) =>
                            handleFlow(flow.id, {
                              audience_type: e.target.value,
                            })
                          }
                          options={[
                            { label: "---", value: "" },
                            { label: "Toda base", value: "Toda base" },
                            {
                              label: "Público de eventos",
                              value: "Público de eventos",
                            },
                            { label: "Público salvo", value: "Público salvo" },
                          ]}
                          filled={!!flow.audience_type}
                        />
                        <Button
                          tabIndex="-1"
                          design="default-icon-mini-2"
                          onClick={() => {
                            setOpenCopyFlow(true);
                            setFieldToCopy({
                              name: "audience_type",
                              value: flow.audience_type,
                            });
                            setToCopy("audience_type");
                            setSelectedFlow(flow);
                          }}
                        >
                          <i className="fal fa-layer-group" />
                        </Button>
                      </div>
                    </td>
                    <td
                      onClick={() => {
                        if (flow.audience_type === "Público salvo") {
                          setOpenAudiences(true);
                          setSelectedFlow(flow);
                        }
                      }}
                    >
                      <div className="d-flex align-center gap-10">
                        <If cond={flow.audience_type === "Público de eventos"}>
                          <Select
                            design="mini"
                            className="w-100"
                            value={flow.audience}
                            onChange={(e) =>
                              handleFlow(flow.id, {
                                audience: e.target.value,
                              })
                            }
                            options={[
                              { label: "---", value: "" },
                              {
                                label: "Cadastro do cliente",
                                value: "CUSTOMER_REGISTER",
                              },
                              {
                                label: "Primeiro pedido",
                                value: "FIRST_ORDER",
                              },
                            ]}
                            filled={!!flow.audience}
                          />
                        </If>
                        <If cond={flow.audience_type === "Público salvo"}>
                          <Input
                            design="mini"
                            className="w-100"
                            value={
                              flow.audience_name ||
                              (audiences || []).find(
                                (a) => a.id === flow.audience,
                              )?.name ||
                              ""
                            }
                            filled={!!flow.audience_name}
                          />
                        </If>
                        <If cond={flow.audience_type === "Toda base"}>
                          <Input
                            design="mini"
                            className="w-100"
                            value="Toda base"
                            readOnly
                            disabled
                          />
                        </If>
                        <If cond={!flow.audience_type}>
                          <Input
                            design="mini"
                            className="w-100"
                            value="---"
                            readOnly
                            disabled
                          />
                        </If>
                        <Button
                          tabIndex="-1"
                          design="default-icon-mini-2"
                          onClick={() => {
                            setOpenCopyFlow(true);
                            if (flow.audience_type === "Toda base") {
                              setFieldToCopy({
                                name: "audience_type",
                                value: flow.audience_type,
                              });
                            }
                            if (flow.audience_type === "Público de eventos") {
                              setFieldToCopy({
                                name: "audience",
                                value: flow.audience,
                              });
                            }
                            if (flow.audience_type === "Público salvo") {
                              setFieldToCopy({
                                name: "audience",
                                value: flow.audience,
                              });
                            }
                            setToCopy("audience");
                            setSelectedFlow(flow);
                          }}
                        >
                          <i className="fal fa-layer-group" />
                        </Button>
                      </div>
                    </td>
                    {(flow.creatives || []).map((c, index) => {
                      const isPercentageDiscount = (type) =>
                        [
                          "PERCENTAGE_DISCOUNT",
                          "CASHBACK",
                          "PRODUCT_DISCOUNT",
                        ].includes(c.coupon_type);

                      return (
                        <Fragment key={index}>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Select
                                design="mini"
                                className="w-100"
                                value={c.type}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "type",
                                    e.target.value,
                                  )
                                }
                                options={[
                                  { label: "SMS", value: "SMS" },
                                  { label: "PUSH", value: "PUSH" },
                                ]}
                                filled={!!c.type}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "type",
                                    value: c.type,
                                    index,
                                  });
                                  setToCopy("creative_type");
                                  setSelectedFlow(flow);
                                }}
                                disabled={!c.type}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Input
                                design="mini"
                                className="w-100"
                                value={c.name}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "name",
                                    e.target.value,
                                  )
                                }
                                filled={!!c.name}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "name",
                                    value: c.name,
                                    index,
                                  });
                                  setToCopy("creative_name");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Select
                                design="mini"
                                className="w-100"
                                value={c.time}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "time",
                                    e.target.value,
                                  )
                                }
                                options={[
                                  { label: "---", value: "" },
                                  ...(getTimes() || []).map((t) => ({
                                    label: t.label,
                                    value: t.value,
                                  })),
                                ]}
                                filled={!!c.time}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "time",
                                    value: c.time,
                                    index,
                                  });
                                  setToCopy("creative_time");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Input
                                design="mini"
                                className="w-100"
                                value={c.sender}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "sender",
                                    e.target.value,
                                  )
                                }
                                filled={!!c.sender}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "sender",
                                    value: c.sender,
                                    index,
                                  });
                                  setToCopy("creative_sender");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Select
                                design="mini"
                                className="w-100"
                                value={c.cta_type}
                                onChange={(e) => {
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "cta_type",
                                    e.target.value,
                                  );

                                  if (e.target.value === "")
                                    handleCreative(flow.id, index, "cta", "");
                                }}
                                options={[
                                  { label: "Não inserir CTA", value: "" },
                                  {
                                    label: "Clube de fidelidade",
                                    value: "STANDARD",
                                  },
                                  {
                                    label: "URL personalizada",
                                    value: "CUSTOM",
                                  },
                                ]}
                                filled={!!c.cta_type}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "cta_type",
                                    value: c.cta_type,
                                    index,
                                  });
                                  setToCopy("creative_cta_type");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Input
                                design="mini"
                                className="w-100"
                                value={
                                  c.cta_type === "STANDARD"
                                    ? Environment.defaultShortUrl
                                    : c.cta
                                }
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "cta",
                                    e.target.value,
                                  )
                                }
                                filled={!!c.cta}
                                disabled={
                                  !c.cta_type || c.cta_type === "STANDARD"
                                }
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                disabled={!c.cta_type}
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "cta",
                                    value: c.cta,
                                    index,
                                  });
                                  setToCopy("creative_cta");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Select
                                design="mini"
                                className="w-100"
                                value={c.contemplation}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "contemplation",
                                    e.target.value,
                                  )
                                }
                                options={[
                                  {
                                    label: "Várias vezes",
                                    value: "SEVERAL_TIMES",
                                  },
                                  { label: "Única", value: "SINGLE_TIME" },
                                ]}
                                filled={!!c.contemplation}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "contemplation",
                                    value: c.contemplation,
                                    index,
                                  });
                                  setToCopy("creative_contemplation");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <BaseCurrencyInput
                                design="mini"
                                className="w-100 pt-0 mb-0"
                                prefix=""
                                suffix=" dias"
                                precision={0}
                                value={c?.contemplation_day_interval}
                                onChange={(v) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "contemplation_day_interval",
                                    v,
                                  )
                                }
                                filled={!!c.contemplation_day_interval}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "contemplation_day_interval",
                                    value: c.contemplation_day_interval,
                                    index,
                                  });
                                  setToCopy(
                                    "creative_contemplation_day_interval",
                                  );
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Select
                                design="mini"
                                className="w-100"
                                value={c.coupon_type}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "coupon_type",
                                    e.target.value,
                                  )
                                }
                                options={[
                                  {
                                    label: "Não conceder cupom",
                                    value: null,
                                  },
                                  {
                                    label: "Desconto em R$",
                                    value: COUPON_TYPE.CASH_DISCOUNT,
                                  },
                                  {
                                    label: "Desconto em %",
                                    value: COUPON_TYPE.PERCENTAGE_DISCOUNT,
                                  },
                                  {
                                    label: "Entrega grátis",
                                    value: COUPON_TYPE.FREE_DELIVERY,
                                  },
                                  {
                                    label: "Desconto em produto",
                                    value: COUPON_TYPE.PRODUCT_DISCOUNT,
                                  },

                                  {
                                    label:
                                      programByPoint !== "POINT"
                                        ? "Cashback"
                                        : "Pontos",
                                    value: COUPON_TYPE.CASHBACK,
                                  },
                                ]}
                                filled={!!c.coupon_type}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "coupon_type",
                                    value: c.coupon_type,
                                    index,
                                  });
                                  setToCopy("creative_coupon_type");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type !== null}>
                                <If
                                  cond={c.coupon_type === COUPON_TYPE.CASHBACK}
                                >
                                  <If cond={programByPoint}>
                                    <BaseCurrencyInput
                                      design="mini"
                                      className="w-100 pt-0 mb-0"
                                      suffix={` ${c.max_gain === 1 ? "ponto" : "pontos"}`}
                                      prefix={""}
                                      precision={0}
                                      value={c.max_gain || 0}
                                      onChange={(v) => {
                                        handleCreative(
                                          flow.id,
                                          index,
                                          "max_gain",
                                          v,
                                        );
                                      }}
                                      disabled={!c?.coupon_type}
                                      readOnly={!c?.coupon_type}
                                    />
                                  </If>
                                  <If cond={!programByPoint}>
                                    <BaseCurrencyInput
                                      className="w-100 pt-0 mb-0"
                                      design="mini"
                                      value={c?.max_gain}
                                      onChange={(n) =>
                                        handleCreative(
                                          flow.id,
                                          index,
                                          "max_gain",
                                          n,
                                        )
                                      }
                                    />
                                  </If>
                                </If>
                                <If
                                  cond={c.coupon_type !== COUPON_TYPE.CASHBACK}
                                >
                                  <Input
                                    design="mini"
                                    className="w-100"
                                    value="---"
                                    readOnly
                                    disabled
                                  />
                                </If>
                              </If>
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "Limite de ganho",
                                    value: c.max_gain,
                                    index,
                                  });
                                  setToCopy("creative_max_gain");
                                  setSelectedFlow(flow);
                                }}
                                disabled={
                                  c.coupon_type !== COUPON_TYPE.CASHBACK
                                }
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <If cond={c.coupon_type !== null}>
                                <If
                                  cond={
                                    c.coupon_type ===
                                    COUPON_TYPE.PRODUCT_DISCOUNT
                                  }
                                >
                                  <Input
                                    value={c?.skus}
                                    design="mini"
                                    className="w-100"
                                    onChange={(e) =>
                                      handleCreative(
                                        flow.id,
                                        index,
                                        "skus",
                                        e.target.value.trim(),
                                      )
                                    }
                                    filled={!!c?.skus}
                                    disabled={!c?.coupon_type}
                                    readOnly={!c?.coupon_type}
                                  />
                                </If>
                                <If
                                  cond={
                                    c.coupon_type !==
                                    COUPON_TYPE.PRODUCT_DISCOUNT
                                  }
                                >
                                  <Input
                                    design="mini"
                                    className="w-100"
                                    value="---"
                                    readOnly
                                    disabled
                                  />
                                </If>
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "SKUs (cupom de produto)",
                                    value: c.skus,
                                    index,
                                  });
                                  setToCopy("creative_coupon_skus");
                                  setSelectedFlow(flow);
                                }}
                                disabled={
                                  c.coupon_type !== COUPON_TYPE.PRODUCT_DISCOUNT
                                }
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type !== null}>
                                <Input
                                  value={c?.coupon_code}
                                  design="mini"
                                  className="w-100"
                                  max={15}
                                  onChange={(e) =>
                                    handleCreative(
                                      flow.id,
                                      index,
                                      "coupon_code",
                                      (e.target.value || "")
                                        .toUpperCase()
                                        .replace(/[^A-Z0-9]/gi, ""),
                                    )
                                  }
                                  filled={!!c?.coupon_code}
                                  disabled={!c?.coupon_type}
                                  readOnly={!c?.coupon_type}
                                />
                              </If>
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "coupon_code",
                                    value: c.coupon_code,
                                    index,
                                  });
                                  setToCopy("creative_coupon_code");
                                  setSelectedFlow(flow);
                                }}
                                disabled={!c?.coupon_type}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type !== null}>
                                <BaseCurrencyInput
                                  className="w-100 pt-0 mb-0"
                                  design="mini"
                                  value={c.coupon_value}
                                  prefix={isPercentageDiscount() ? "" : "R$ "}
                                  suffix={isPercentageDiscount() ? "%" : ""}
                                  onChange={(v) =>
                                    handleCreative(
                                      flow.id,
                                      index,
                                      "coupon_value",
                                      v,
                                    )
                                  }
                                  disabled={!c?.coupon_type}
                                  readOnly={!c?.coupon_type}
                                />
                              </If>
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "coupon_value",
                                    value: c.coupon_value,
                                    index,
                                  });
                                  setToCopy("creative_coupon_value");
                                  setSelectedFlow(flow);
                                }}
                                disabled={!c?.coupon_type}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type !== null}>
                                <BaseCurrencyInput
                                  className="w-100 pt-0 mb-0"
                                  design="mini"
                                  value={c.min_order}
                                  onChange={(v) =>
                                    handleCreative(
                                      flow.id,
                                      index,
                                      "min_order",
                                      v,
                                    )
                                  }
                                  disabled={!c?.coupon_type}
                                  readOnly={!c?.coupon_type}
                                />
                              </If>
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "min_order",
                                    value: c.min_order,
                                    index,
                                  });
                                  setToCopy("creative_min_order");
                                  setSelectedFlow(flow);
                                }}
                                disabled={!c?.coupon_type}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type !== null}>
                                <BaseCurrencyInput
                                  className="w-100 pt-0 mb-0"
                                  design="mini"
                                  suffix={" dia(s)"}
                                  prefix={""}
                                  precision={0}
                                  value={c?.expiration}
                                  onChange={(v) =>
                                    handleCreative(
                                      flow.id,
                                      index,
                                      "expiration",
                                      v,
                                    )
                                  }
                                  disabled={!c?.coupon_type}
                                  readOnly={!c?.coupon_type}
                                />
                              </If>
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "expiration",
                                    value: c.expiration,
                                    index,
                                  });
                                  setToCopy("creative_expiration");
                                  setSelectedFlow(flow);
                                }}
                                disabled={!c?.coupon_type}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <If cond={c.coupon_type !== null}>
                                <Select
                                  design="mini"
                                  className="w-100"
                                  value={c.operation_type}
                                  onChange={(e) =>
                                    handleCreative(
                                      flow.id,
                                      index,
                                      "operation_type",
                                      e.target.value,
                                    )
                                  }
                                  disabled={!c?.coupon_type}
                                  readOnly={!c?.coupon_type}
                                  options={[
                                    { label: "---", value: "" },
                                    { label: "Delivery", value: "Delivery" },
                                    { label: "Salão", value: "Salão" },
                                    {
                                      label: "Para viagem",
                                      value: "Para viagem",
                                    },
                                    {
                                      label: "Consumo no local",
                                      value: "Consumo no local",
                                    },
                                    {
                                      label: "Salão, Delivery",
                                      value: "Salão, Delivery",
                                    },
                                    {
                                      label: "Salão, Para viagem",
                                      value: "Salão, Para viagem",
                                    },
                                    {
                                      label: "Salão, Consumo no local",
                                      value: "Salão, Consumo no local",
                                    },
                                    {
                                      label: "Delivery, Para viagem",
                                      value: "Delivery, Para viagem",
                                    },
                                    {
                                      label: "Delivery, Consumo no local",
                                      value: "Delivery, Consumo no local",
                                    },
                                    {
                                      label: "Para viagem, Consumo no local",
                                      value: "Para viagem, Consumo no local",
                                    },
                                    { label: "Todas", value: "Todas" },
                                  ]}
                                  filled={!!c.operation_type}
                                />
                              </If>
                              <If cond={c.coupon_type === null}>
                                <Input
                                  design="mini"
                                  className="w-100"
                                  value="---"
                                  readOnly
                                  disabled
                                />
                              </If>
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "operation_type",
                                    value: c.operation_type,
                                    index,
                                  });
                                  setToCopy("creative_operation_type");
                                  setSelectedFlow(flow);
                                }}
                                disabled={!c?.coupon_type}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <If cond={brands.length > 1}>
                            <td
                              onClick={() => {
                                if (c.coupon_type !== null) {
                                  setOpenBrands(true);
                                  setSelectedCreative({
                                    ...c,
                                    flow_id: flow.id,
                                    index,
                                  });
                                }
                              }}
                            >
                              <div className="d-flex align-center gap-10">
                                <If cond={!c.brands_valid}>
                                  <Input
                                    design="mini"
                                    className="w-100"
                                    value="---"
                                  />
                                </If>
                                <If cond={c.brands_valid}>
                                  <Input
                                    value={brands
                                      .filter((b) =>
                                        c.brands_valid?.includes(b.id),
                                      )
                                      .map((b) => b.name)
                                      .join(", ")}
                                    design="mini"
                                    className="w-100"
                                    readOnly
                                  />
                                </If>
                                <Button
                                  tabIndex="-1"
                                  design="default-icon-mini-2"
                                  onClick={() => {
                                    setOpenCopyCreative(true);
                                    setFieldToCopy({
                                      name: "brands_valid",
                                      value: c.brands_valid,
                                      index,
                                    });
                                    setToCopy("creative_brands_valid");
                                    setSelectedFlow(flow);
                                  }}
                                  disabled={!c?.brands_valid}
                                >
                                  <i className="fal fa-layer-group" />
                                </Button>
                              </div>
                            </td>
                          </If>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Input
                                value={c?.message_title}
                                design="mini"
                                className="w-100"
                                max={isCocoBambu ? 45 : 75}
                                maxLength={isCocoBambu ? 45 : 75}
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "message_title",
                                    e.target.value,
                                  )
                                }
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "message_title",
                                    value: c.message_title,
                                    index,
                                  });
                                  setToCopy("creative_message_title");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-center gap-10">
                              <Input
                                value={c?.message_body}
                                design="mini"
                                className="w-100"
                                max={MAX_CHARS_PER_SMS}
                                maxLength={
                                  c.type === "PUSH"
                                    ? isCocoBambu
                                      ? 107
                                      : MAX_CHARS_PUSH
                                    : MAX_CHARS_PER_SMS
                                }
                                onChange={(e) =>
                                  handleCreative(
                                    flow.id,
                                    index,
                                    "message_body",
                                    e.target.value,
                                  )
                                }
                                filled={!!c?.message_body}
                              />
                              <Button
                                tabIndex="-1"
                                design="default-icon-mini-2"
                                onClick={() => {
                                  setOpenCopyCreative(true);
                                  setFieldToCopy({
                                    name: "message_body",
                                    value: c.message_body,
                                    index,
                                  });
                                  setToCopy("creative_message_body");
                                  setSelectedFlow(flow);
                                }}
                              >
                                <i className="fal fa-layer-group" />
                              </Button>
                            </div>
                          </td>
                          <td>
                            <Button
                              design="secondary-mini"
                              className="w-100"
                              onClick={() => {
                                setSelectedCreative({
                                  ...c,
                                  flow_id: flow.id,
                                  index,
                                });
                                setOpenSendTest(true);
                              }}
                            >
                              Testar criativo
                            </Button>
                          </td>
                        </Fragment>
                      );
                    })}
                    <td>
                      <Button
                        design="secondary-mini"
                        className="w-100"
                        onClick={() =>
                          setFlows((f) => {
                            return f.map((u) =>
                              u.id === flow.id
                                ? {
                                    ...u,
                                    creatives: [
                                      ...(u?.creatives || []),
                                      emptyCreative,
                                    ],
                                  }
                                : u,
                            );
                          })
                        }
                      >
                        Adicionar criativo
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className={styles.footer}>
          <Button onClick={() => setOpenAddMultiple(true)} className="gap-15">
            <i className="fas fa-plus" />
            Adicionar múltiplos fluxos
          </Button>
          <Button
            onClick={() => setFlows([...flows, { id: uuid(), ...emptyFlow }])}
            className="gap-15"
          >
            <i className="fas fa-plus" />
            Adicionar fluxo
          </Button>
          <Button onClick={save} design="primary" disabled={!flows.length}>
            Criar fluxos
          </Button>
        </div>
      </div>

      <Drawer
        visible={openCopyFlow}
        onClose={() => setOpenCopyFlow(false)}
        title={`Replicar dado - ${getCopyName()}`}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todos os fluxos
              selecionados.
            </p>
          </div>
          <div className={styles.toCopy}>{fieldToCopy?.value}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              let updated = updateFlowsByIds(
                flows,
                selectedFlows,
                fieldToCopy.name,
                fieldToCopy.value,
              );

              setFlows(updated);
              setSelectedFlows([]);
              setOpenCopyFlow(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyCreative}
        onClose={() => setOpenCopyCreative(false)}
        title={`Replicar dado - ${getCopyName()}`}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todos os fluxos
              selecionados.
            </p>
          </div>
          <div className={styles.toCopy}>{fieldToCopy?.value}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              const updated = updateCreativeFlowByIds(
                flows,
                selectedFlows,
                fieldToCopy.name,
                fieldToCopy.value,
                fieldToCopy.index,
              );

              setFlows(updated);
              setSelectedFlows([]);
              setOpenCopyCreative(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openAudiences}
        onClose={() => setOpenAudiences(false)}
        withoutTransition
        direction="full-center"
        showCloseButton={false}
      >
        <div className={styles.audiences}>
          <div className={styles.audiencesHeader}>
            <p className={styles.title}>Públicos salvos</p>
            <div className="d-flex align-center">
              <div
                className={styles.close}
                onClick={() => setOpenAudiences(false)}
              >
                <i className="fas fa-times" />
              </div>
            </div>
          </div>
          <div className={styles.audiencesContainer}>
            <AudiencesTable
              audiences={audiences}
              onSelect={(audience) => setSelectedAudience(audience)}
              selectedAudience={selectedAudience}
            />
          </div>

          <div className={styles.audiencesFooter}>
            <Button
              design="primary"
              disabled={!selectedAudience}
              onClick={() => {
                const s = selectedAudience;
                handleFlow(selectedFlow?.id, {
                  audience: s.id,
                  audience_name: s.name,
                });
                setSelectedAudience(null);
                setOpenAudiences(false);
              }}
            >
              Selecionar público
            </Button>
          </div>
        </div>
      </Drawer>

      <Drawer
        visible={openConfirmRemove}
        onClose={() => setOpenConfirmRemove(false)}
        title="Remover fluxo"
        direction="center"
      >
        <div className="d-flex justify-center mb-20">
          <Label>Tem certeza que deseja remover o fluxo?</Label>
        </div>

        <div className="d-flex gap-15 w-100">
          <Button className="w-100" onClick={() => setOpenConfirmRemove(false)}>
            Cancelar
          </Button>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              handleDeleteFlow(selectedFlow?.id);
              setOpenConfirmRemove(false);
            }}
          >
            Sim, remover
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openAddMultiple}
        onClose={() => setOpenAddMultiple(false)}
        title="Adicionar múltiplos fluxos"
      >
        <Label>Insira quantos fluxos deseja adicionar</Label>
        <Input
          value={flowsToAdd}
          onChange={(e) => setFlowsToAdd(e.target.value)}
          autoFocus
        />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!flowsToAdd || flowsToAdd > 100}
            onClick={() => {
              const newFlows = Array.from({ length: flowsToAdd }, () => ({
                ...emptyFlow,
                id: uuid(),
              }));

              setFlows([...flows, ...newFlows]);
              setOpenAddMultiple(false);
              setFlowsToAdd("");
            }}
          >
            Adicionar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openSendTest}
        onClose={() => setOpenSendTest(false)}
        title="Envio de teste"
      >
        <If cond={selectedCreative.type === "SMS"}>
          <SmsTriggerShot />
        </If>
        <If cond={selectedCreative.type === "PUSH"}>
          <PushTriggerShot />
        </If>
      </Drawer>

      <Drawer
        visible={openSuccess}
        onClose={() => setOpenSuccess(false)}
        direction="center"
        showCloseButton={false}
      >
        <div className={styles.success}>
          <p className={styles.title}>Sucesso!</p>
          <p className={styles.subtitle}>
            Os fluxos foram criados com sucesso.
          </p>
          <Button className="w-100" onClick={() => setOpenSuccess(false)}>
            Fechar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openError}
        onClose={() => setOpenError(false)}
        direction="center"
        showCloseButton={false}
      >
        <div className={styles.success}>
          <p className={styles.title}>Erro ao salvar</p>
          <p className={styles.subtitle}>{errorMessage}</p>
          <Button className="w-100" onClick={() => setOpenError(false)}>
            Voltar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openBrands}
        onClose={() => {
          setOpenBrands(false);
          setSelectedCreative({});
        }}
        title="Marcas"
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => setOpenBrands(false)}
          >
            Confirmar
          </Button>
        }
      >
        <BenefitEnvironment
          benefit={flows
            .find((f) => f.id === selectedCreative.flow_id)
            ?.creatives?.find((c) => c.id === selectedCreative.id)}
          brands={brands}
          onChange={(data) => {
            console.log(
              "selectedCreative",
              flows.find((f) => f.id === selectedCreative.flow_id),
            );
            updateCreative(
              selectedCreative.flow_id,
              selectedCreative.index,
              "brands_valid",
              data.brands_valid,
            );
          }}
        />
      </Drawer>
    </div>
  );
}
